import React, { useEffect, useRef } from 'react';
import ga4Events from '../ga4Events';

const SECTION_IDS = [
  'home',
  'key_features',
  'about_us',
  'text_list',
  'services',
  'how_it_works',
  'reviews',
  'faq',
  'interface',
  'download',
  'footer',
];

function ScrollTracker() {
  const reachedRef = useRef(new Set());

  useEffect(() => {
    const reached = reachedRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const id = entry.target.id;
          if (!id || reached.has(id)) return;
          reached.add(id);
          ga4Events.scroll.sectionReached(id);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -20% 0px', // trigger when at least 20% of section is visible from bottom
        threshold: 0,
      },
    );

    SECTION_IDS.forEach((sectionId) => {
      const el = document.getElementById(sectionId);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return null;
}

export default ScrollTracker;
